import { EditorPerformanceObserver } from './editorPerformanceObserver';
import { TimelineController } from './timeline';
export var getGlobalEditorMetricsObserver = function getGlobalEditorMetricsObserver(options) {
  var observer = globalThis.__editor_performance_metrics_observer;
  if (observer) {
    return observer;
  }
  var timeline = new TimelineController();
  observer = new EditorPerformanceObserver(timeline, options);
  globalThis.__editor_performance_metrics_timeline = timeline;
  globalThis.__editor_performance_metrics_observer = observer;
  return observer;
};